import { useTranslation } from 'react-i18next';

import { Props as KpiTableProps } from '../../../../KpiTable';
import { LeftBorderTableCell } from '../../styled';
import AddMonthButton from '../AddMonthButton/AddMonthButton';
import { FlexContainer, FlexGrowDiv, PositionAbsoluteDiv, PositionRelativeDiv } from './styled';

const NoteAddMonthCell = (props: Pick<KpiTableProps, 'canAddNewMonth' | 'addMonth'>) => {
    const { canAddNewMonth, addMonth } = props;
    const { t } = useTranslation();

    return (
        <LeftBorderTableCell>
            <FlexContainer>
                <FlexGrowDiv style={{ fontWeight: '500' }}>
                    {t('pages.plastic_assessment.tabs.kpi.table.note')}
                </FlexGrowDiv>
                <PositionRelativeDiv>
                    <PositionAbsoluteDiv>
                        <AddMonthButton canAddNewMonth={canAddNewMonth} addMonth={addMonth} />
                    </PositionAbsoluteDiv>
                </PositionRelativeDiv>
            </FlexContainer>
        </LeftBorderTableCell>
    );
};

export default NoteAddMonthCell;